export default __webpack_public_path__ + "static/media/much-more.4628feb4.svg";